document.addEventListener("DOMContentLoaded", function () {
    let offsetBackgrounds = document.querySelectorAll(".offset-background");

    function setWidth(element, totalMoveAmount) {
        if (window.innerWidth < 848) {
            element.style.width = "100vw";
        } else {
            element.style.width =
                "calc(80% + " + Math.abs(totalMoveAmount) + "px" + ")";
        }
    }

    function handleResize() {
        checkIfOffsetBackgroundIsAffixedLeft(offsetBackgrounds, setWidth);
    }

    window.addEventListener("resize", cmpDebounce(handleResize, 100));
    checkIfOffsetBackgroundIsAffixedLeft(offsetBackgrounds, setWidth);

    var seeFullListButton = document.querySelector(".see-full-list-button");

    if (seeFullListButton) {
        seeFullListButton.addEventListener("click", function (e) {
            e.preventDefault();
            var cards = e.currentTarget.parentNode.querySelectorAll(".card");
            for (var i = 0; i < cards.length; i++) {
                cards[i].classList.add("show");
            }
            seeFullListButton.style.display = "none";
        });
    }
});
